import { Syllabus } from './Syllabus'

export interface SyllabusWithExpirateDate extends Syllabus {
  expirateDate: Date
}

export function isExpiring (object: any): object is SyllabusWithExpirateDate {
  return 'expireDate' in object
}
